import _ from 'underscore';
import axios from 'axios'
import store from '../state/store';

store.on('users:current', function() {
  axios.get("/api/sales/users/current")
  .then(function(response) {
    store.get().set({user: response.data})
  })
  .catch(function(error) {
    handleError(error)
  })
});

